import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxSkeletonComponent } from './phx-skeleton.component';

@NgModule({
  declarations: [
    PhxSkeletonComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PhxSkeletonComponent
  ]
})
export class PhxSkeletonModule { }
